import { Icon, type IconProps, Box } from "@chakra-ui/react";
import React from "react";

export function QuoteIcon(props: IconProps) {
  return (
    <Icon viewBox="0 0 45 43" {...props}>
      <Box as="g" clipPath="url(#quote-a)">
        <Box
          as="path"
          fill="currentColor"
          d="M5.97 16.829c1.518-1.956 3.918-2.831 6.663-2.831 5.074 0 8.741 3.384 8.741 9.09 0 5.36-3.428 9.912-10.63 9.912C4.13 33-.005 28.331-.005 20.753 0 10.618 6.173 2.66 17.341.03c.658-.152 1.386.249 1.61.885l.226.635c.225.636-.12 1.263-.777 1.45C11.031 5.04 6.566 9.474 5.454 16.65c-.098.662.097.719.511.179h.005Zm23.62 0c1.519-1.956 3.919-2.831 6.664-2.831 5.074 0 8.741 3.384 8.741 9.09 0 5.36-3.428 9.912-10.63 9.912-6.614 0-10.75-4.669-10.75-12.247C23.62 10.618 29.799 2.66 40.976.03c.658-.152 1.386.249 1.61.885l.226.635c.225.636-.12 1.263-.777 1.45-7.37 2.04-11.835 6.474-12.947 13.65-.106.662.097.719.503.179Z"
        />
      </Box>
      <Box as="defs">
        <Box as="clipPath" id="quote-a">
          <Box as="path" fill="#fff" d="M0 0h45v33H0z" />
        </Box>
      </Box>
    </Icon>
  );
}
